import RolesManagementContainer from "../../components/RolesManagement/RolesManagementContainer";

function RolesManagementPage() {
  return <RolesManagementContainer />
}

export default RolesManagementPage;